module.exports = {
	"settings": {
		"main": {
			"general": "Configurações gerais",
			"setup": "Configurações",
			"account_information": "Informações da conta",
			"describe_account_information": "Nome da empresa e outras informações que serão apresentadas para seu cliente em seu endereço de acesso.",
			"your_location": "Sua localização",
			"describe_your_location": "Dados de endereço que serão utilizados para cálculos em planos que realiza a cobrança de frete.",
			"block": "Bloqueio",
			"describe_block": "Regra referente ao bloqueio automatico da assinatura de seu cliente.",
			"name": "Nome",
			"company_name": "Razão social",
			"trade_name": "Nome fantasia",
			"telephone": "Telefone",
			"email": "E-mail",
			"url": "Endereço de acesso",
			"prefix_url": ".assinaturas.traycheckout.com.br",
			"postal_code": "CEP",
			"address": "Endereço",
			"complement": "Complemento",
			"seller_code": "Código do vendedor",
			"city": "Cidade",
			"state": "Estado",
			"customer_data": "Dados do cliente",
			"set_rules": "Defina algumas regras referente ao cadastro e assinatura do cliente.",
			"allowed_store_registration": "Cadastro permitido na loja",
			"choose_person_type": "Escolha um tipo de pessoa",
			"only_natural_person": "Somente pessoa física",
			"only_legal_person": "Somente pessoa jurídica",
			"both_type_person": "Pessoa Física e Jurídica",
			"field_required": "Campo obrigatório no cadastro",
			"field_address_required": "Campo obrigatório no cadastro",
			"expiration_date_ticket": "Data de vencimento do boleto",
			"days": "dias",
			"subscription_block": "Bloqueio de assinatura",
			"mark_client_as_overdue": "Marcar cliente como inadimplente após 10 dias do vencimento da fatura.",
			"mark_client_as": "Marcar cliente como inadimplente após",
			"days_invoice_expiration": "dias do vencimento da fatura.",
			"payment_acquirer": "Meio de pagamento",
			"enter_bank_details": "Ao clicar no botão você será redirecionado a uma página que lista todos nossos meios de pagamento, onde você pode configurar a forma de recebimento de suas faturas.",
			"set_up_billet": "Você poderá configurar recebimentos com boleto, transferência bancária e cartões de crédito ou débito de diversas bandeiras.",
			"billet_expiration_date": "Data de vencimento do boleto",
			"choose_your_billet_bank": "Selecione o adquirente de boleto",
			"choose_your_reprocess_billet_bank": "Selecione o adquirente de reprocessamento de boleto",
			"select_bank": "Você pode configurar mais de um adquirinte de boleto, porém deve selecionar apenas um para processar suas faturas, sinta-se a vontade para muda-lô sempre que necessário.",
			"id_conv": "Código de convênio",
			"tp_pagamento": "Código de cobrança",
			"msg_loja": "Instruções ao cliente",
			"forgot_zipcode": "Não sei meu CEP",
			"number": "Número",
			"optional": "opcional",
			"merchant_id_bradesco": "Idenfificador bradesco",
			"carteira_bradesco": "Carteira bradesco",
			"token_bradesco": "Chave de segurança bradesco",
			"email_bradesco": "Email",
			"return_url": "URL de retorno",
			"codigo_empresa": "Código da empresa",
			"chave": "Chave",
			"postal_code_not_found": "Endereço não encontrado",
			"neighborhood": "Bairro",
			"token_traycheckout": "Token de Integração",
			"billing_settings": "Configurações de faturamento",
			"billing_setting_description": "Configurações relacionadas as preferências de faturamento, tais como: tornar assinatura inadimplente, inativar contratos atrasados, cancelar assinatura por falta de primeiro pagamento e gerar faturas com alguns dias antes do vencimento do contrato.",
			"billing_setting_value": "Valor da configuração",
			"webhook_settings": "Configurações de Webhook",
			"webhook_setting_url": "Url de notificação",
			"webhook_setting_description": "Configurações relacionadas à URL de notificação por Webhook, um recurso de integração com outros sistemas, o qual possibilita colocar uma URL padrão para receber notificações dos eventos disponíveis.",
			"choose_your_card_gateway": "Selecione o adquirente de cartão",
			"choose_your_reprocess_card_gateway": "Selecione o adquirente de reprocessamento de cartão",
			"nfe_settings": "Configurações de Notas Fiscais",
			"nfe_setting_value": "Valor da configuração",
			"nfe_gateway_config_title": "Configurações de emissão",
			"nfe_setting_description": "Configurações para a geração de Notas Fiscais Eletrônicas que serão emitidas e enviadas por email",
			"payment_methods": "Formas de pagamento",
			"include_payment_method": "Incluir forma de pagamento",
			"integration": "Integração",
			"integration_data": "Dados da integração",
			"all_methods": "Todas as formas de pagamento",
			"edit_payment_method": "Editar forma de pagamento",
			"set_status_item": "Alterar status",
			"select_payment_method": "Selecionar meio de pagamento",
			"edit_payment_methods": "Editar formas de pagamento",
			"payment_data": "Configurações da forma de pagamento",
			"choose_your_transfer_gateway": "Selecione a forma de transferência",
			"choose_your_balance_method": "Selecione a forma de pagamento com saldo",
			"yapay_token": "Token Yapay"
		},
		"label": {
			"municipal_registration": "Inscrição Municipal",
			"configure_new": "Configure uma nova forma de pagamento para sua adquirente. Você também pode editar os já configurados",
			"select_payment_method": "Selecione a forma de pagamento que será adicionado.",
			"enter_data_from_acquirer_to_setup_payment_method": "Informe os dados informados pela adquirente para configurar a forma de pagamento.",
			"set_configurations": "Defina as configurações da formas de pagamento.",
			"billing_setting": "Configurações de faturamento",
			"webhook_setting": "Eventos passíveis de notificação",
			"nfe_setting_generate": "Deseja gerar notas fiscais?",
			"nfeio_api_key": "Chave de acesso para Nota Fiscal (API key)",
			"nfeio_company_id": "ID da empresa",
			"nfeio_service_code": "Código de serviço",
			"nfeio_webhook_secret": "Senha para autenticação de Webhooks (HMAC)",
			"nfe_setting_days": "Deseja gerar quantos dias antes do vencimento?",
			"inactive_item": "Deseja realmente <strong>inativar</strong> o meio de pagamento?",
			"active_item": "Deseja realmente <strong>ativar</strong> o meio de pagamento?",
			"edit_all_warning": "Ao realizar a edição, as configuração serão aplicadas a todas formas de pagamento.",
			"set_configurations_all": "Defina as configurações das formas de pagamento. Todas as formas listadas abaixo sofrerão as alterações.",
			"saved_payment_methods": "Metodos de pagamento salvos.",
			"choose_option": "Escolha uma opção",
			"error": {
				"field_required": "Campo obrigatório"
			},
			"messages": {
				"duplicate_billet_methods": "O adquirente de boleto principal deve ser diferente do adquirente de reprocessamento.",
				"duplicate_card_methods": "O adquirente de cartão principal deve ser diferente do adquirente de reprocessamento.",
				"email_available": "Email disponível.",
				"invalid_quantity_days_nfe": "Quantidade de dias deve ser menor que os dias para a geração de fatura recorrente antes do vencimento. Menor ou igual a %{billingSetting} dias",
				"invalid_quantity_days_billing": "Quantidade de dias deve ser maior que a quantidade de dias para geração de Notas Fiscais antes do vencimento."
			},
			"buttons": {
				"check_availability": "Verificar Disponibilidade",
				"add_payment_method": "Incluir forma de pagamento",
				"check_all": "Marcar todos",
				"uncheck_all": "Desmarcar todos",
				"config_payment_method": "Configurar forma de pagamento"
			}
		},
		"placeholder": {
			"company_name": "Ex.: Agência ABC",
			"trade_name": "Ex.: ABC",
			"telephone": "Ex.: (11) 4423-3652",
			"email": "Ex.: atendimento@try.com.br",
			"name": "Ex.: José da Silva",
			"postal_code": "Ex.: 00000-000",
			"address": "Ex.: Rua A",
			"city": "Ex.: São Paulo",
			"number": "Ex.: 123",
			"neighborhood": "Ex.: Bairro da Luz",
			"billing_setting_value": "Ex.: 5",
			"webhook_setting_value": "https://api_exemplo.com/recebe_notificacao"
		},
		"tooltip": {
			"merchant_id_bradesco": "Identificador do estabelecimento fornecido pelo Bradesco",
			"carteira_bradesco": "Número da carteira no Bradesco",
			"token_bradesco": "Chave de acesso utilizada na comunicação entre Loja e Plataforma Bradesco",
			"email_bradesco": "E-mail utilizado para logar no gerenciador do Bradesco",
			"return_url_shopline": "URL de retorno que deverá ser informada no painel do Shopline.",
			"codigo_empresa": "Código da empresa junto ao Itau Shopline.",
			"chave": "Chave de integração do Itau Shopline",
			"id_conv": "Código do convênio fornecido pelo BB.",
			"tp_pagamento": "Código do cobrança que controla o pagamento, fornecido pelo BB.",
			"msg_loja": "Instruções que serão apresentadas no boleto de cobrança.",
			"chave_boleto_bradesco": "Chave utilizada para pagamento com boleto.",
			"token_traycheckout": "Token de identificação da conta Traycheckout",
			"billing_setting": "Valor para definir a configuração de faturamento",
			"webhook_setting": "Url para definir a configuração de Webhook",
			"nfe_setting": "Valor de dias que deseja gerar a Nota Fiscal antes do vencimento da fatura"
		},
		"attributes": {
			"payment_methods": "Formas de pagamento",
			"bb_online": "Banco do Brasil",
			"bradesco": "Bradesco",
			"itau": "Itaú Shopline",
			"yapay": "Yapay - Intermediador",
			"cielo": "Cielo",
			"getnet": "Getnet",
			"select_acquirer": "Selecione um adquirente",
			"none": "Nenhum",
			"type": "Tipo de forma de pagamento",
			"direct": "Redirecionamento para o banco"
		},
		"billing_attributes": {
			"contract_overdue": "Dias para definir uma assinatura como inadimplente por falta de pagamento",
			"contract_cancel_overdue": "Dias para cancelar uma assinatura após inadimplência",
			"contract_cancel_pending": "Dias para cancelar uma assinatura por falta de primeiro pagamento",
			"invoice_interval": "Dias para geração da fatura antes de seu vencimento",
			"payment_max_split": "Número de parcelas permitido na fatura quando paga com cartão de crédito",
			"payment_days_to_generate": "Dias para o vencimento da primeira fatura a partir da contratação",
			"invoices_generation_on_overdue": "Gerar fatura mesmo que inadimplente"
		},
		"webhook_attributes": {
			"invoice": "Notificação de alterações e criação de faturas",
			"contract": "Notificação de alterações e criação de assinaturas"
		},
		"alerts": {
			"nf_seller_success": "Configuração para Nota Fiscal realizada com sucesso!",
			"nf_communication_error": "Erro na comunicação com o sistema de Nota Fiscal",
			"nf_seller_failure": "Falhou ao tentar atualizar as configurações no sistema de Nota Fiscal",
			"active_payment_method": "Item ativado!",
			"inactive_payment_method": "Item desativado!",
			"action_success": "Ação realizada!",
			"payment_methods_not_found": "Nenhuma forma de pagamento configurada",
			"action_warning": "Ação não realizada!",
			"gateway_communication_error": "Erro na comunicação com o gateway!",
			"processor_not_found": "Adquirente não existente!"
		},
		"button": {
			"edit_all": "Editar todos"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/settings/pt-BR.yml
// module id = 592
// module chunks = 1